import React from 'react';
import styled from 'styled-components/macro';
import Modal from './Modal';

const Button = styled.button`
  font-family: Inter, Helvetica;
  font-size: 0.875rem;
  line-height: 28px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.1s ease-in 0s;
  outline: none;
  padding: 0.2rem 2rem;
  border-radius: 5px;
  background-color: rgb(31, 93, 234);
  border: 1px solid rgb(31, 93, 234);
  color: white;
`;

const CancelButton = styled(Button)`
  background-color: rgb(220, 53, 69);
  border: 1px solid rgb(220, 53, 69);
`;

const Title = styled.p`
  padding: 0 1rem;
  font-family: Inter, Helvetica;
  font-weight: 500;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  min-width: 20rem;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
`;

interface Props {
  title: string;
  onCancel: () => void;
  onConfirm: () => void;
  isOpen: boolean;
}

const Prompt = ({ title, onCancel, onConfirm, isOpen }: Props) => {
  return (
    <Modal open={isOpen}>
      <Container>
        <Title>{title}</Title>
        <Content>
          <Button onClick={onConfirm}>Confirm</Button>
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
        </Content>
      </Container>
    </Modal>
  );
};

export default Prompt;
